module.exports = __webpack_public_path__ + "static/media/ios-laptop.617fdd4a.svg";